import { ProfileYourAwardsCard } from './profile-your-awards-card'
import React from 'react'
import { Grid } from 'src/component/ui/grid/grid'
import { Challenge, NotCompletedChallenge } from 'src/dao/core-dao'

export const ProfileNotCompletedChallanges = ({
  notCompletedChallenge,
}: {
  notCompletedChallenge: NotCompletedChallenge
}): React.ReactElement => {
  return (
    <div className="mb-[30px]">
      <h3 className="text-ivory font-evogria text-xl md:text-2xl font-normal leading-6 tracking-[1px] uppercase mb-10">
        {notCompletedChallenge.category.name}
      </h3>
      <ProfileNotCompletedChallangesSection notCompletedChallenges={notCompletedChallenge.challenges} />
    </div>
  )
}

const ProfileNotCompletedChallangesSection = ({
  notCompletedChallenges,
}: {
  notCompletedChallenges: { challenge: Challenge; progress: number }[]
}): React.ReactElement => {
  if (notCompletedChallenges.length === 0) {
    return <span className={'pl-3'}>No awards</span>
  }

  return (
    <>
      <Grid
        columns={6}
        items={notCompletedChallenges}
        keyExtractor={(item) => item.challenge.id}
        renderItem={(item) => (
          <ProfileYourAwardsCard
            key={item.challenge.id}
            challenge={item.challenge}
            progress={item.progress}
            isCompleted={false}
            isStarted={typeof item.progress === 'number' || item.challenge.autoStarted}
          />
        )}
      />
    </>
  )
}
